module.exports = __webpack_public_path__ + "media/images/app/collections/collection-diamond-f2c8cc84d48ef1176263c80d574feee1.webp";